export type CursorPageInfo = {
  hasNextPage: boolean;
  endCursor: string | null;
};

/**
 * Normalizes a nullable GraphQL pageInfo into a strict cursor page-info shape.
 */
export function toPageInfo(
  page: { hasNextPage?: boolean | null; endCursor?: string | null } | undefined
): CursorPageInfo {
  return {
    hasNextPage: page?.hasNextPage ?? false,
    endCursor: page?.endCursor ?? null,
  };
}
